export default class Store {
  private storage: Storage;

  constructor(type: 'local' | 'session') {
    if (type === 'local') {
      this.storage = window.localStorage;
    } else {
      this.storage = window.sessionStorage;
    }
  }

  set(key: string, value: unknown): void {
    let val;
    try {
      val = JSON.stringify(value);
    } catch (error) {
      val = value;
    }
    this.storage.setItem(key, val as string);
  }

  get<T>(key: string): T {
    const value: string | null = this.storage.getItem(key);
    let res;
    try {
      res = JSON.parse(value as string);
    } catch (e) {
      // res = value;
    }
    return typeof res === 'undefined' ? value : res;
  }

  del(key: string): void {
    this.storage.removeItem(key);
  }

  flush(): void {
    this.storage.clear();
  }
}
